export default {
	name: 'conversation-modal',
	props: ['show', 'user_id', 'url', 'view_id'],

	mounted() {
		window.addEventListener('message', this.handleMessage, false)
	},

	beforeDestroy() {
		window.removeEventListener('message', this.handleMessage)
	},

	methods: {
		close(e) {
			this.$root.$emit('showConversationModal', {})
		},

		handleMessage(ev) {
			var dat = ev.data
			if (!dat.type) return
			if (dat.from == 'conversation_modal') {
				switch (dat.type) {
					case 'create_order':
						console.log('CREATING ORDER', dat)
						store.createOrder(dat.order)
						break
					case 'send_message':
						this.$root.$emit('conversationModalMessage_send', dat.message, this.view_id)
						break
					case 'apply_message':
						this.$root.$emit('conversationModalMessage', dat.message, this.view_id)
						break
					case 'get_user':
						let user = store.matchUser(this.user_id)
						ev.source.postMessage({from: 'subiz', _id: dat._id, body: {user: user}}, this.url)
						break
					case 'close':
						if (true || this.view_id === dat.view_id) this.close()
						break
				}
				return
			}
			switch (dat.type) {
				case 'create_order':
					console.log('CREATING ORDER', dat)
					store.createOrder(dat.order)
					break
				case 'tag_conversation':
					store.tagConvo(dat.conversation_id, dat.tag_id)
					break
				case 'message':
					this.$root.$emit('conversationModalMessage', dat.message, this.view_id)
					break
				case 'close':
					if (true || this.view_id === dat.view_id) this.close()
					break
			}
		},
	},

	render() {
		let cls = 'modal'
		if (!this.show) cls += ' modal__hide'

		return (
			<Modal show={this.show} zindex={1000} vOn:bg={this.close} width='800px' height='600px'>
				<div title='Đóng' style='top: -30px' class='product_select_close' vOn:click_stop={this.close}>
					<Icon name='x' size='1x' stroke-width='3' />
				</div>
				<div style='overflow: hidden; width: 100%; height: 100%'>
					<iframe
						src={this.url}
						width='100%'
						height='100%'
						style='border: none; background: white; border-radius: 8px;'
					/>
				</div>
			</Modal>
		)
	},
}
